<template>
  <div class="flex px-4 py-2 space-x-10">
    <!-- Left Side -->
    <div
      class="w-3/5 bg-white rounded-md shadow-xl"
    >
      <div
        class="flex p-2 space-x-2 bg-gray-100 border border-gray-200 rounded-md"
      >
        <button
          class="px-4 py-2 text-white rounded-md"
          :class="selected.name === rule.name ? 'bg-success' : 'bg-blue-400'"
          v-for="rule in form.rules"
          :key="rule.name"
          @click="selected = rule"
        >
          {{ rule.name }}
        </button>
      </div>
      <prism-editor
        class="my-editor"
        v-model="selected.codeContent"
        :highlight="highlighter"
        line-numbers
        readonly
        :key="prismRendererKey"
      ></prism-editor>
    </div>
    <!-- Right Side -->
    <div class="w-2/5 space-y-10">
      <div class="px-4 py-6 bg-white rounded-md shadow-xl">
        <h3 class="mb-6 text-xl font-semibold text-gray-700">Rule Details</h3>
        <div class="flex justify-between mb-4">
          <p class="text-gray-600 text-md">Rule Name:</p>
          <p class="text-lg">{{ form.name }}</p>
        </div>
        <div class="flex flex-wrap space-x-2">
          <p class="mr-auto text-gray-600 text-md">Mitre Attack Techniques:</p>
          <vx-tooltip
            :title="technique"
            color="#00c3ff"
            position="left"
            v-for="(technique, index) in form.mitreIds"
            :key="index"
          >
            <vs-chip color="#00c3ff" class="product-order-status">{{
              technique
            }}</vs-chip>
          </vx-tooltip>
        </div>
      </div>
      <div class="p-4 bg-white rounded-md shadow-xl">
        <p class="mb-2 text-xl font-semibold text-gray-700">Description</p>
        <quill-editor
          id="description"
          ref="description"
          disabled
          v-model="form.description"
          :options="editorOption"
        />
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";
import "prismjs/components/prism-ruby";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-markup";
import "prismjs/components/prism-yaml";
import "prismjs/components/prism-xml-doc";
import "prismjs/components/prism-python";
import "prismjs/components/prism-json";

export default {
  components: {
    vSelect,
    quillEditor,
    PrismEditor,
  },
  data() {
    return {
      prismRendererKey: 0,
      editorOption: {
        modules: {
          toolbar: false,
        },
      },
      selected: {
        name: null,
        languageType: null,
        codeContent: null,
      },
      form: {
        _id: null,
        name: null,
        mitreIds: [],
        description: null,
        rules: [],
      },
    };
  },
  methods: {
    onEditorChange({ quill }) {
      this.form.description = quill;
    },
    highlighter(code) {
      if (languages[this.selected.languageType]) {
        return highlight(code, languages[this.selected.languageType]);
      } else {
        return highlight(code, languages.markup);
      }
    },
    async fetchRuleData(id) {
      try {
        const response = await this.$http.get("/user/rules", {
          params: {
            id: id,
          },
        });
        let { _id, name, mitreIds, description, rules } = response.data.result;
        this.form = { _id, name, mitreIds, description, rules };
        if (this.form.rules && this.form.rules.length > 0) {
          this.selected = this.form.rules[0];
        }
      } catch (e) {}
    },
  },
  computed: {
    editor() {
      return this.$refs.description.quill;
    },
  },
  created() {
    this.fetchRuleData(this.$route.params.id);
  },
};
</script>

<style>
.my-editor {
  background: #2d2d2d;
  color: #ccc;
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
  max-height: 500px;
}

.prism-editor__textarea:focus {
  outline: none;
}

.ql-editor {
  max-height: 300px !important;
}
</style> 